import moment from 'moment';

const getVisibleEntries = (entries, { text, sortBy, searchBy, showDivison, startDate, endDate }) => {
  const divisionFilter = (entry, division) => {
    return entry.entry_type === 'hand_in' ? false : entry.division_name.toLowerCase() === division.toLowerCase();
  };

  return entries.filter((entry) => {
    const effectiveDate = moment(entry.effective_date);
    const postedDate = moment(entry.created_at);
    const dateRange = sortBy === 'effectiveDate' ? effectiveDate : postedDate;
    const startDateMatch = startDate ? startDate.isSameOrBefore(dateRange, 'day') : true;
    const endDateMatch = endDate ? endDate.isSameOrAfter(dateRange, 'day') : true;
    const textMatch = entry[searchBy].toLowerCase().startsWith(text.toLowerCase());
    const disivionMatch = showDivison === 'All' ? true : divisionFilter(entry, showDivison);
    return startDateMatch && endDateMatch && textMatch && disivionMatch;
  });
  // .sort((a, b) => {
  //   switch (sortBy) {
  //     case 'effectiveDate':
  //       return a.effective_date < b.effective_date ? 1 : -1;
  //     case 'postedDate':
  //       return a.postedDate < b.postedDate ? 1 : -1;
  //     case 'amount':
  //       return a.total < b.total ? 1 : -1;
  //     default:
  //       return a.effective_date < b.effective_date ? 1 : -1;
  //   }
  // });
};

export default getVisibleEntries;



// WEBPACK FOOTER //
// ./src/selectors/entries.js